/**
 * Check whether a value is a string array
 *
 * @param value - The value to check
 * @returns Whether or not the arguments is a string array
 */
export function isStringArray(value: unknown): value is string[] {
    return !!value && Array.isArray(value) && value.every((item): item is string => !!item && typeof item === 'string');
}
